import React from 'react';
import TextField from 'material-ui/TextField';
import ShortForm from './ShortForm';
import Page from './Page';

export default class ChangePasswordConfirmation extends Page {

	constructor(...args){
		super(...args);
		window.app.resetPasswordForm2.username = '';
		window.app.resetPasswordForm2.password = '';
		window.app.resetPasswordForm2.confirmPassword = '';
		window.app.resetPasswordForm2.resetCode = '';
	}

	render(){
		return (
			<ShortForm
				label="Change Your Password"
				submitButton={{label:"CHANGE PASSWORD", onClick:() => { window.app.resetPasswordForm2.submit()}}}
				waiting={window.app.resetPasswordForm2.loading}
				errorMessage={window.app.resetPasswordForm2.errorMessage}
				>
				<TextField
					label="Email"
					id="username"
					defaultValue={window.app.resetPasswordForm2.username}
					onChange={ e => window.app.resetPasswordForm2.username = e.currentTarget.value }
					margin="normal"
					fullWidth/>

				<TextField
					label="New Password"
					type="password"
					id="password"
					defaultValue={window.app.resetPasswordForm2.password}
					onChange={ e => window.app.resetPasswordForm2.password = e.currentTarget.value }
					margin="normal"
					fullWidth/>

				<TextField
					label="Confirm New Password"
					type="password"
					id="confirm-password"
					defaultValue={window.app.resetPasswordForm2.confirmPassword}
					onChange={ e => window.app.resetPasswordForm2.confirmPassword = e.currentTarget.value }
					margin="normal"
					fullWidth/>

				<TextField
					label="Verification Code From Email"
					id="resetCode"
					defaultValue={window.app.resetPasswordForm2.resetCode}
					onChange={ e => window.app.resetPasswordForm2.resetCode = e.currentTarget.value }
					margin="normal"
					fullWidth/>
			</ShortForm>
		)
	}
}





// WEBPACK FOOTER //
// ./src/components/ChangePasswordConfirmation.js